import React from 'react';
import type { ConsentItemType, ConsentProfile } from 'types/nhis';
import ConsentDetail1 from './ConsentDetail1';
import ConsentDetail2 from './ConsentDetail2';
import ConsentDetail3 from './ConsentDetail3';
import ConsentDetail4 from './ConsentDetail4';
import ConsentDetail5 from './ConsentDetail5';
import ConsentDetail6 from './ConsentDetail6';
import ConsentDetail6Kmrs from './ConsentDetail6Kmrs';

/** 동의 화면 판을 전문 컴포넌트에 전달 — 5번이 제공받는 자(담당 약사) 소속 문구 변형에 사용한다. */
export interface ConsentDetailProps {
  profile?: ConsentProfile;
}

export const CONSENT_DETAIL_COMPONENTS: Record<ConsentItemType, React.FC<ConsentDetailProps>> = {
  PERSONAL_INFO: ConsentDetail1,
  RESIDENT_NUMBER: ConsentDetail2,
  SENSITIVE_INFO: ConsentDetail3,
  AI_OVERSEAS_TRANSFER: ConsentDetail4,
  THIRD_PARTY: ConsentDetail5,
  CARINGNOTE_THIRD_PARTY: ConsentDetail6,
  PARTNER_THIRD_PARTY: ConsentDetail6Kmrs,
};

export { default as ConsentDetail1 } from './ConsentDetail1';
export { default as ConsentDetail2 } from './ConsentDetail2';
export { default as ConsentDetail3 } from './ConsentDetail3';
export { default as ConsentDetail4 } from './ConsentDetail4';
export { default as ConsentDetail5 } from './ConsentDetail5';
export { default as ConsentDetail6 } from './ConsentDetail6';
export { default as ConsentDetail6Kmrs } from './ConsentDetail6Kmrs';
